import React from "react";
import colors from "@streeteasy/design-system/deprecated/colors";
import { bool, oneOf, string } from "prop-types";

import { BedroomsOutline, BedroomsWrapper, IconWrapper } from "./styled";

/**
 * Static BedroomsIcon component
 */

const BedroomsIcon = ({
  desktopPadding,
  isWrapped,
  mobilePadding,
  strokeColor,
  width
}) => (
  <IconWrapper
    aria-hidden
    desktopPadding={desktopPadding}
    mobilePadding={mobilePadding}
  >
    <BedroomsWrapper viewBox="0 0 21 13" width={width}>
      <BedroomsOutline
        fill="none"
        fillRule="evenodd"
        isWrapped={isWrapped}
        strokeColor={strokeColor}
      >
        <path
          d="M18.273 1.72a.222.222 0 0 0-.22-.22H3.78c-.12 0-.22.1-.22.22v5.49h14.713V1.72z"
          strokeLinecap="round"
        />
        <path
          d="M3.56 7.208H1.72a.221.221 0 0 0-.22.221v3.016c0 .121.099.221.22.221h18.393c.12 0 .22-.1.22-.22V7.428a.22.22 0 0 0-.22-.22h-1.84"
          strokeLinecap="round"
        />
        <path
          d="M5.606 6.979V4.667c0-.17.099-.308.22-.308H9.72c.12 0 .22.139.22.309v2.31m2.074.155V4.595c0-.13.076-.236.169-.236h3.907c.122 0 .22.139.22.308v2.466"
          strokeLinecap="square"
        />
        <path
          d="M3.548 10.758v1.379m14.768-1.379v1.379"
          strokeLinecap="round"
        />
      </BedroomsOutline>
    </BedroomsWrapper>
  </IconWrapper>
);

BedroomsIcon.propTypes = {
  /** A string with information about desktop padding styles */
  desktopPadding: string,
  /** Indicates if the BedroomsIcon should receive color behavior from a parent */
  isWrapped: bool,
  /** A string with information about padding on mobile devices. Default is null */
  mobilePadding: string,
  /** Give the icon a stroke color (must be a color from the SE color library) */
  strokeColor: oneOf(Object.keys(colors)),
  /** Give the icon width/height (default is 21px) */
  width: string
};

BedroomsIcon.defaultProps = {
  desktopPadding: "0 6px",
  isWrapped: false,
  mobilePadding: "",
  strokeColor: "koalaGrey",
  width: "21px"
};

export default BedroomsIcon;
